<div class="py-4 lg:py-8 overflow-y-auto">
  <!-- Loading bar -->
  @if (isLoading) {
    <mat-progress-bar class="absolute inset-x-0 bottom-0 h-0.5" mode="indeterminate">
    </mat-progress-bar>
  }
  <!-- Questions -->
  @if (typeFamilies) {
    <div class="space-y-2">
      @for (family of getFamiliesList(); track family) {
        <div class="w-3/4 relative flex items-center py-2 px-4 font-medium text-base rounded-full cursor-pointer text-hint hover:bg-hover"
          (click)="family.expanded = !family.expanded">
          <mat-icon class="text-current" [svgIcon]="family.icon"></mat-icon>
          <div class="ml-3 leading-5 select-none text-default">
            {{ family.caption | localize }}
          </div>
          <mat-icon class="ml-auto"
            [svgIcon]="family.expanded ? 'heroicons_solid:chevron-down' : 'heroicons_solid:chevron-right'">
          </mat-icon>
        </div>
        <div [class.hidden]="!family.expanded" class="ml-4">
          @for (type of family.component; track type) {
            <div
              (click)="addComponent(type)" matRipple>
              @if (!type.notForDesign) {
                <div class="w-max relative flex items-center py-2 px-4 text-base rounded-full cursor-pointer text-hint hover:bg-hover">
                  <mat-icon class="text-current" [svgIcon]="type.icon"></mat-icon>
                  <div class="ml-3 leading-5 select-none text-default">
                    {{ type.caption | localize }}
                  </div>
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
  }
</div>